export const newProjectId = 'prj_new';

export enum originalPolotnoTypes {
    Video = 'video',
    Image = 'image',
    Text = 'text',
    Figure = 'figure',
    Line = 'line',
    Svg = 'svg',
    Group = 'group',
}

export enum customPolotnoTypes {
    Avatar = 'avatar',
}

export enum polotnoTypes {
    Video = originalPolotnoTypes.Video,
    Group = originalPolotnoTypes.Group,
    Image = originalPolotnoTypes.Image,
    Text = originalPolotnoTypes.Text,
    Figure = originalPolotnoTypes.Figure,
    Line = originalPolotnoTypes.Line,
    Avatar = customPolotnoTypes.Avatar,
    Svg = originalPolotnoTypes.Svg,
}

export enum SIDEBAR_PANELS {
    TEMPLATES = 'templates',
    SHAPES = 'shapes',
    AVATARS = 'avatars',
    SCRIPT = 'script',
    BACKGROUND = 'background',
    TEXT = 'text',
    MEDIA = 'media',
}

export interface MenuItem {
    key: string;
    srcValue: string;
    name: string;
    type: string;
}

export enum ProjectAutoSaveStatus {
    Idle,
    Saving,
    Saved,
    Error,
}
